import React from "react";
import styles from "../style.module.scss";

const CoffeeUserRewardsTable = ({ tableData }) => {
  const formatDateTime = (timestamp) => {
    if (!timestamp) return "--";
    const date = new Date(timestamp);
    const dateStr = date.toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return dateStr;
  };

  return (
    <>
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {/* <th>ID</th> */}
              <th>User</th>
              <th>Email</th>
              <th>Redeem Location</th>
              <th>Redeem Date/Time</th>
            </tr>
          </thead>
          <tbody>
            {tableData && tableData?.length > 0 ? (
              tableData.map((data, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <p>{data?.user?.full_name || "--"}</p>
                    </td>
                    <td>
                      <p>{data?.user?.email || "--"}</p>
                    </td>
                    <td>
                      <p>{data?.redeemed_at_location?.name || "--"}</p>
                    </td>
                    <td>
                      <p>{formatDateTime(data?.unlocked_at)}</p>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={4} className={styles.noData}>
                  <p style={{ textAlign: "center" }}>No data found</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CoffeeUserRewardsTable;
